import React, { useState } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { BorderedDropDown } from '../../HouseStyle/Components/DropDowns';
import ColorPickerModal from '../Components/ColorPicker';
import { ButtonBlue, ButtonLightGrey } from '../../HouseStyle/Components/Buttons';

const Step3ColorFont = ({ data, updateData, onNext, onPrev }) => {
  const [formData, setFormData] = useState({
    selectedColors: data.selectedColors || ['#ffffff', '#009FE3', '#025A7A', '#000000', '#9C9C9C'],
    font: data.font || 'Nunito',
    phone_number_country_code: data.phone_number_country_code || '',
    phone_number: data.phone_number || ''
  });

  // Color picker states
  const [showColorModal, setShowColorModal] = useState(false);
  const [editingColorIndex, setEditingColorIndex] = useState(null);
  const [currentEditingColor, setCurrentEditingColor] = useState('#ffffff');

  const availableFonts = [
    { value: 'Nunito', label: 'Nunito' },
    { value: 'Arial', label: 'Arial' },
    { value: 'Helvetica', label: 'Helvetica' },
    { value: 'Georgia', label: 'Georgia' },
    { value: 'Times New Roman', label: 'Times New Roman' }
  ];

  const handleFontChange = (font) => {
    const updatedData = {
      ...formData,
      font: font
    };
    
    setFormData(updatedData);
    updateData({ font: font });
  };

  const handleColorEdit = (index) => {
    const currentColor = formData.selectedColors[index];
    setEditingColorIndex(index);
    setCurrentEditingColor(currentColor);
    setShowColorModal(true);
  };

  const handleColorModalClose = () => {
    setShowColorModal(false);
    setEditingColorIndex(null);
    setCurrentEditingColor('#ffffff');
  };

  const handleColorSave = (newColor) => {
    if (editingColorIndex !== null) {
      const newColors = [...formData.selectedColors];
      newColors[editingColorIndex] = newColor;
      
      const updatedData = {
        ...formData,
        selectedColors: newColors
      };
      
      setFormData(updatedData);
      updateData({ selectedColors: newColors });
    }
  };

  const handleNext = () => {
    onNext();
  };

  const handlePrev = () => {
    onPrev();
  };

  return (
    <div className="step-container">
      <div className="step-content-area">
        <div className="step-form">
          <h2 className="step-title">Kleuren & Lettertype</h2>
          {/* Color Selection Section */}
          <div className="color-section">
            <h3>5 kleuren</h3>
            <div className="color-swatches">
              {formData.selectedColors.map((color, index) => (
                <div key={index} className="color-swatch-container">
                  <div
                    className="color-swatch"
                    style={{ backgroundColor: color, cursor: 'pointer' }}
                    onClick={() => handleColorEdit(index)}
                  >
                    <div className="color-edit-overlay">
                      <FontAwesomeIcon icon={faPlus} style={{ color: 'white', fontSize: '12px' }} />
                    </div>
                  </div>
                  <div className="color-hex">
                    {color}
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          <div className='d-flex flex-row justify-content-between'>
            {/* Font Selection Section */}
            <div className="font-section">
              <h3>Font kiezen</h3>
              <div className="form-group">
                <BorderedDropDown
                  size="s"
                  placeholder="Kies een lettertype"
                  selectedValue={formData.font}
                  setSelectedValue={handleFontChange}
                  options={availableFonts.map((font) => ({
                    key: font.value,
                    value: font.value,
                    title: font.label
                  }))}
                />
              </div>
            </div>

            {/* Font Preview Section */}
            <div className="preview-text-font">
              <h2 style={{ fontFamily: formData.font }}>Voorbeeld</h2>
              <p style={{ fontFamily: formData.font }}>
                Dit is een voorbeeldtekst om het gekozen lettertype en de kleuren van 
                uw huisstijl te tonen. Een sterke visuele identiteit zorgt voor 
                herkenbaarheid en vertrouwen bij uw klanten. Kies kleuren en een font 
                die passen bij uw merk en boodschap.
              </p>
            </div>
          </div>
        </div>
        {/* Color Picker Modal */}
        <ColorPickerModal
          show={showColorModal}
          onHide={handleColorModalClose}
          initialColor={currentEditingColor}
          onSave={handleColorSave}
        />
      </div>
      {/* Navigation Buttons */}
      <div className="form-actions">
        <ButtonLightGrey
          onClickFunction={handlePrev}
          text="Terug"
        />
        <ButtonBlue
          onClickFunction={handleNext}
          text="Verder"
        />
      </div>
    </div>
  );
};

export default Step3ColorFont;